import { render, staticRenderFns } from "./churuJy.vue?vue&type=template&id=cb07e79c&scoped=true"
import script from "./churuJy.vue?vue&type=script&lang=js"
export * from "./churuJy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb07e79c",
  null
  
)

export default component.exports